import { HttpInterceptorFn } from '@angular/common/http'
import { RecaptchaService } from '@app/services/recaptcha.service'
import { inject } from '@angular/core'
import { switchMap } from 'rxjs/operators'
import { from } from 'rxjs'

const protectedPaths = [
    '/customer',
    '/electronic-processes/search',
    '/electronic-processes/download/',
    '/electronic-processes/'
]

export const recaptchaInterceptor: HttpInterceptorFn = (request, next) => {
    const recaptchaService = inject(RecaptchaService)
    const isProtected = protectedPaths.some((path) => request.url.includes(path))

    if (!isProtected) {
        return next(request)
    }

    const action = resolveAction(request.url)

    return from(recaptchaService.execute(action)).pipe(
        switchMap((token) => next(request.clone({
            setHeaders: {
                'x-recaptcha-token': token,
                'x-recaptcha-action': action
            }
        })))
    )
}

function resolveAction(path: string): string {
    if (path.includes('/customer')) {
        return 'customer'
    }

    if (path.includes('/electronic-processes/search')) {
        return 'search'
    }

    if (path.includes('/electronic-processes/download/')) {
        return 'download'
    }

    if (path.includes('/details')) {
        return 'details'
    }

    return 'generic_action'
}
